import 'Styles/register.scss';

import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';

import { normalize, schema } from 'normalizr';

import registerUserSelector from 'Selectors/registerUserSelector';
import CheckboxComponent from 'Components/common/CheckboxComponent';

import SvgIcon from 'Components/svg/SvgIcon';
import LoaderCss from 'Components/common/LoaderCssComponent';

import { checkUserName, registerUserName } from 'Actions/authenticateActions';
import { receiveCurrentUser } from 'Actions/UstateActions';
import { receiveGlobalMeta } from 'Actions/MetaActions';
import { getFetchConfig } from 'Actions/GlobalMetaActions';
import { displayNotification } from 'Actions/UiActions';
import { pingServer } from 'Actions/GlobalMetaActions';

class RegisterComponent extends React.Component {
	constructor( props ) {
		super( props );
		this.timerCheckUserName = null;

		this.state = {
			nameOk: true,
			suggestedName: null,
			provider: null,
			uri: null,
			forum_rules: 'Loading...'
		}
	}

	componentDidMount() {
		this.setState( {
			provider: this.props.location.query.provider,
			uri: this.props.location.query.uri || null,
			nameOk: this.props.location.query.ok === '1'
		} );

		// Ping server for user info
		this.props.dispatch( pingServer() );

		this.repositionScroll();
		this.props.dispatch( receiveGlobalMeta( null, 'Register New User', this.props.siteTitle ) );
		this.retrieveForumRules();
	}

	componentDidUpdate() {
		this.repositionScroll();
	}

	repositionScroll = () => {
		if( this.header ) {
			let headerDim = this.header.getBoundingClientRect();
			let _form = ReactDOM.findDOMNode( this.form );
			if( _form && headerDim.height ) {
				_form.style.marginTop = `${ headerDim.bottom }px`;
			}
		}
	};

	/**
	 * retrieves the forum rules
	 */
	retrieveForumRules() {
		let config = this.props.dispatch( getFetchConfig( true ) );

		const user = new schema.Entity('users');

		return fetch( `${ this.props.siteUrl }?v=3.0&ajax=1&object=forum_rules&req=get&_=${ new Date().getTime() }`, config ).then( ( response ) => {
			if( response.ok ) {
				response.json().then( ( json ) => {
					if( json.forum_rules ) {
						this.setState( {
							forum_rules: json.forum_rules || 'error loading forum rules'
						} );
						let result = Object.assign(
							{},
							normalize(
								{
									users: json.forumUser.data
								},
								{
									users: [ user ]
								}
							)
						);
						let new_ustate = json.ustate;
						try {
							let currentUser = result.entities.users[ new_ustate.id ];
							new_ustate = Object.assign( {}, new_ustate, { userName: currentUser.userName, avatar: currentUser.avatar, online: currentUser.online, lastActivity: currentUser.lastActivity } );
						} catch( e ) {
							new_ustate = Object.assign( {}, new_ustate, { userName: null, avatar: null, online: null, lastActivity: null } );
						}

						this.props.dispatch( receiveCurrentUser( new_ustate ) );
					}
				})
			}
		} );
	}

	verifyUserName() {
		if( this.timerCheckUserName ) {
			clearTimeout( this.timerCheckUserName );
			this.timerCheckUserName = undefined;
		}

		this.timerCheckUserName = setTimeout( () => {
			let username = this.username.value;
			this.setState = this.setState.bind( this );
			if( username ) {
				this.props.dispatch( checkUserName( username ) ).then( response => {
					// in case we get the return too late and the input already changed
					if( username !== this.username.value ) {
						return true;
					}
					if( response.username ) {
						this.setState( {
							nameOk: true,
							suggestedName: false
						} );
					} else {
						this.setState( {
							nameOk: false,
							suggestedName: decodeURIComponent( response.suggestedusername )
						} );
					}
				} );
			} else {
				this.setState( {
					nameOk: false,
					suggestedName: decodeURIComponent( this.props.location.query.suggestedusername ) || ''
				} );
			}
		}, 400 );
	}

	validateLogin() {
		let pass = this.props.location.query.pass === '1' ? ( this.password.value && this.password && /.+/.test( this.password.value ) ) : true;
		return ( pass && this.username && /[^\s]+/.test( this.username.value ) );
	}

	toggleShowRules() {
		this.forum_rules_container.classList.toggle( 'hidden' );
	}

	submitForm = ( e ) => {
		e.preventDefault();

		if( this.forum_rules_agree.state.itemChecked === false ) {
			this.forum_rules_agree_container.classList.add( 'alert' );
			let message = 'You must agree with the Forum rules';
			displayNotification( 'error', message, { force: true } );
			return false;
		} else {
			this.forum_rules_agree_container.classList.remove( 'alert' );
		}
		if( this.validateLogin() ) {
			const data = {
				provider: this.state.provider,
				username: this.username.value,
				password: this.props.location.query.pass === '1' ? this.password.value : null,
				agree: this.forum_rules_agree.state.itemChecked ? 1 : 0,
				uri: this.state.uri
			};
			this.props.dispatch( registerUserName( data ) );
		} else {
			let message = 'Please provide a valid User Name' + ( this.props.location.query.pass === '1' ? ' and Password' : '' );
			displayNotification( 'error', message, { force: true } );
			return false;
		}
	};

	render() {
		// Only for VS sites with Integrated Registration form
		if( this.props.location.query.isvs === '1' ) {
			if( !this.props.registerUrl ) {
				return <LoaderCss />;
			}

			let redirectUrl = this.props.location.query.uri ? this.props.location.query.uri : '',
				registration_url = `${ this.props.registerUrl }${ /\?/i.test( this.props.registerUrl ) ? '&' : '?' }mobileurl=${ redirectUrl ? redirectUrl : '/' }`;

			let content = <div className="register">
				<header className="thread" ref={ ( h ) => this.header = h }>
					<h2>Register at</h2>
					<h3>{ this.props.siteTitle }</h3>
				</header>
				<div className="register-form" ref={ ( h ) => this.form = h }>
					<p>You are not registered.</p>
					<p>We are redirecting you to our registration form.</p>
					<p className="note">
						Or click <a href={ registration_url }>Register with the forum</a>
					</p>
				</div>
			</div>;

			setTimeout( () => { document.location.replace( registration_url ); }, 1000 );

			return content;
		}

		let fields = {
				username: {
					label: 'Choose your User Name',
					input_placeholder: 'choose your user name',
					input_default: decodeURIComponent( this.props.location.query.suggestedusername ) || ''
				},
				password: {
					label: 'Password',
					input_placeholder: 'password'
				}
			},
			suggestion = this.state.suggestedName ?
				<span>Our suggestion: <strong>{ this.state.suggestedName }</strong></span> : null,
			validUserName = this.state.nameOk ? <p> </p> :
				<p className="action-button alert note">
					<SvgIcon size="16px" icon="warning"/>
					User name already used, try a different one. { suggestion }
				</p>,
			passwordNeeded = this.props.location.query.pass && this.props.location.query.pass === '1' ?
				<div key={ `password_label` } className="field styled-field">
					<label className="field-label">
						{ fields.password.label }
						<input name="password"
							required='required' type="password" placeholder={ fields.password.input_placeholder }
							ref={ ( p ) => this.password = p }/>
					</label>
				</div> : null;

		return (
			<div className="register">
				<header className="thread" ref={ ( h ) => this.header = h }>
					<h2>Register at</h2>
					<h3>{ this.props.siteTitle }</h3>
				</header>
				<div className="register-form" ref={ ( h ) => this.form = h }>
					<form className="modal-form" onSubmit={ this.submitForm }>
						<div key={ `username_label` } className="field styled-field">
							<label className="field-label">
								{ fields.username.label }
								<input className={ this.state.nameOk ? 'isok' : 'alert' } name="username"
									   required='required' type="text" placeholder={ fields.username.input_placeholder }
									   defaultValue={ fields.username.input_default ? fields.username.input_default : null }
									   ref={ ( u ) => this.username = u } onChange={ ( e ) => this.verifyUserName( e ) } />
							</label>
							{ validUserName }
						</div>
						{ passwordNeeded }
						<div className="note">Your account will be associated with your <strong>{ this.props.location.query.provider }</strong> account</div>
						<div className="note" ref={ (fr) => this.forum_rules_agree_container = fr }>
							<CheckboxComponent
								name="agree"
								id="cb_rules_agree"
								value="1"
								className="inLine"
								checked={ false }
								multiple={ true }
								ref={ (fr) => this.forum_rules_agree = fr }
							/>
							<span>Yes, I agree with the <span style={ { textDecoration: 'underline' } } onClick={ () => this.toggleShowRules() }>Forum Rules</span></span>
							<div id="forum-rules" className="hidden" ref={ (fr) => this.forum_rules_container = fr }>
								<a className="close-forumrules" onClick={ () => this.toggleShowRules() }>hide<SvgIcon icon="angle_up" size="16px" /></a>
								<div dangerouslySetInnerHTML={ { __html: this.state.forum_rules } } />
								<a className="close-forumrules" onClick={ () => this.toggleShowRules() }>hide<SvgIcon icon="angle_up" size="16px" /></a>
							</div>
						</div>
						<div className="modal-buttons">
							<input className="action-button" type="submit" value="Register"/>
						</div>
					</form>
				</div>
			</div>
		);
	}
}

export default connect( registerUserSelector )( RegisterComponent );



// WEBPACK FOOTER //
// ./src/components/RegisterComponent.js